var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMaiSazio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1995_7668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 1024C794.77 1024 1024 794.77 1024 512C1024 229.23 794.77 0 512 0C229.23 0 0 229.23 0 512C0 794.77 229.23 1024 512 1024Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.992 425.845C528.558 382.189 548.313 340.35 567.952 298.478C587.188 257.501 606.392 216.458 625.512 175.416C637.111 150.543 649.23 142.379 669.564 146.078C691.634 150.096 713.762 173.122 715.206 195.189C719.459 259.733 722.989 324.341 727.096 388.917C732.39 472.531 737.596 556.146 743.582 639.726C746.851 685.17 751.537 730.485 755.76 775.832C758.681 807.083 749.743 815.757 729.553 819.744C708.901 823.826 690.044 806.35 688.018 781.571C679.889 682.81 671.82 584.048 664.677 485.224C659.672 416.15 656.201 346.95 651.718 272.934C647.523 281.706 645.123 286.488 642.895 291.366C610.963 360.95 579.089 430.565 547.098 500.115C544.495 505.76 541.718 511.469 538.161 516.41C527.863 530.888 511.925 535.736 498.534 525.149C486.704 515.805 475.713 503.624 467.699 490.262C434.033 434.008 401.665 376.768 368.663 320.003C362.01 308.555 354.662 297.586 345.003 282.214C343.788 293.534 342.66 300.008 342.456 306.483C339.94 384.995 337.684 463.538 335.14 542.05C332.362 627.992 329.47 713.902 326.432 799.813C325.536 825.229 316.453 833.806 292.33 833.202C270.609 832.659 259.125 820.477 259.848 796.466C262.364 712.659 265.286 628.853 268.351 545.048C272.257 438.442 276.393 331.867 280.529 225.261C280.76 219.456 282.12 213.717 282.525 207.88C284.03 185.334 294.327 169.739 313.618 162.757C332.218 156.028 353.072 164.478 365.655 184.314C390.183 223.061 414.392 262.091 437.706 301.699C461.279 341.72 483.609 382.635 507.963 425.813L507.992 425.845Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1995_7668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaiSazio);
export default __webpack_public_path__ + "static/media/logo-mai-sazio.be76715dbc13e7359c0c43cdd00aba4c.svg";
export { ForwardRef as ReactComponent };